import styled from "styled-components";
// import {BREAKPOINT} from '../../lib/styles';
import { gray, red } from "../../utils/styles";

const BREAKPOINT = "770px";

const InputStyles = styled.div`
    input {
        height: 44px;
        width: 100%;
        background: ${gray(100)};
        border: 1px solid ${gray(200)};
        border-radius: 4px;
        font-size: 16px;
    }
    input::placeholder {
        color: ${gray(300)};
        outline: 0;
        font-size: 12px;
    }
    input.error,
    input.error:focus,
    input.error:focus-visible {
        border: 2px solid ${red()};
    }
    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 30px white inset;
    }
    label {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: bold;
        color: ${gray(500)};
    }
    .label-container {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }
    .checkbox-input__container label {
      font-size: 12px;
    }
    .helper-text-container {
        display: flex;
        align-items: center;
    }
    .helper-text-container .tooltip-wrapper {
        display: block;
        margin-left: 6px;
    }
    .helper-text,
    .label__max-char {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        font-style: italic;
        color: ${gray(400)};
    }
    .required-asterisk {
        margin: 0 4px;
        color: ${red()};
    }
    .reference-number {
        font-size: 8px;
        font-weight: 700;
        vertical-align: top,
        color: ${red()};
    }
    input:focus,
    input:focus-visible {
        border: 2px solid ${(props) =>
          props.$primary_color ? props.$primary_color : "#2459a9"};
        outline: none;
        background: #fff;
    }
    .input-container {
        margin-bottom: 15px;
        border: 1px solid green;
    }
    .input-error {
        font-size: 12px;
        color: ${red()};
        font-weight: bold;
        margin-top: 10px;
        display: inline-block;
    }
    select {
        width: 100%;
        height: 45px;
        padding: 0 10px;
        border-radius: 4px;
        background: ${gray(100)};
        border: 1px solid ${gray(200)};
    }
    select:focus,
    select:focus-visible {
        border: 2px solid ${(props) =>
          props.$primary_color ? props.$primary_color : "#2459a9"};
        outline: none;
    }
    input.checkbox {
        width: 20px;
        height: 20px;
    }
    fieldset {
        border: none !important;
    }
    .checkbox-input__container {
        display: grid;
        grid-template-columns: 20px auto;
        grid-gap: 10px;
    }
    .checkbox-multi-container  .label-container {
        margin-bottom: 8px;
        font-weight: bold;
    }
    .checkbox-multi__options {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 8px;
    }
    @media screen and (min-width: ${BREAKPOINT}){
        .checkbox-multi__options {
            grid-template-columns: repeat(${(props) =>
              props.columns || 1}, 1fr);
        }

    }
    .checkbox-multi__option {
        display: flex;
        align-items: center;
    }
    .checkbox-multi__option > input {
        margin-right: 8px;
        max-height: fit-content;
        margin-bottom: 0;
        cursor: pointer;
    }
    textarea {
        width: 100%;
        box-sizing: border-box;
        border-radius: 4px;
        min-height: 140px;
        padding: 8px;
        font-family: inherit;
        outline: none;
        background: ${gray(100)};
        border: 2px solid ${gray(200)};
    }
    textarea:focus,
    textarea:focus-visible {
      border: 2px solid ${(props) =>
        props.$primary_color ? props.$primary_color : "#2459a9"};
      background: #fff;
    }

`;
export default InputStyles;
